// extracted by mini-css-extract-plugin
export default {"container":"CompanyCellRenderer_container__1C+1P","chip":"CompanyCellRenderer_chip__4kM7r"};